export default "__VITE_ASSET__a08c9683__"